import React from "react";
import { isBoolean } from "lodash";
import { localize, shorten as shortenNumber } from "@backpacker/number";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { percent } from "@tootools/number";
import Tooltip from ".";

interface IProps {
  content?: React.ReactNode;
  footer?: React.ReactNode;
  locale: Locale;
  subLabel?: string;
  total?: number;
  shorten?: boolean;
  count: number;
  label: string;
  color?: string;
  withSubLabel?: boolean;
}

const TooltipSerie = ({
  content,
  footer,
  locale,
  count,
  label,
  color,
  subLabel,
  total,
  shorten,
  withSubLabel,
}: IProps) => (
  <Tooltip
    content={
      content
        ? content
        : isBoolean(shorten) && !shorten
        ? localize(locale, count)
        : shortenNumber(locale, count)
    }
    label={label}
    color={color}
    subLabel={
      subLabel
        ? subLabel
        : total && withSubLabel
        ? `${tr(locale, "PUNCTUATION::COLON")} ${shortenNumber(
            locale,
            percent(count, total)
          )}%`
        : null
    }
    footer={footer}
  />
);

export default TooltipSerie;
